//read more read less feature
document.addEventListener('DOMContentLoaded', function() {
  var toggleLink = document.getElementById('toggle-description');
  var shortDescription = document.getElementById('short-description');
  var fullDescription = document.getElementById('full-description');

  toggleLink.addEventListener('click', function(event) {
    event.preventDefault();
    if (fullDescription.classList.contains('hidden')) {
      fullDescription.classList.remove('hidden');
      shortDescription.classList.add('hidden');
      toggleLink.textContent = 'Read less';
    } else {
      fullDescription.classList.add('hidden');
      shortDescription.classList.remove('hidden');
      toggleLink.textContent = 'Read more';
    }
  });
});
//read more read less feature




